import { Injectable, Injector } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { GenericIdbaResponseModel } from '../models/generic-idba-response-model';
import { ErrorHandlerService } from '../services/error-handler.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  private errorHandler: ErrorHandlerService;

  constructor(private injector: Injector) { }

  private get handler(): ErrorHandlerService {
    return (this.errorHandler ??= this.injector.get(ErrorHandlerService));
  }

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      catchError((error: unknown) => {
        const httpError = error as { status?: number; url?: string };
        if (httpError?.status === 401 && !httpError.url?.includes('/auth/refresh')) {
          return throwError(() => error);
        }

        this.handler.handleError(new GenericIdbaResponseModel(error));
        return throwError(() => error);
      }),
      tap((event: HttpEvent<unknown>) => {
        if (event instanceof HttpResponse) {
          this.handler.handleResponse(new GenericIdbaResponseModel(event.body));
        }
      }),
    );
  }
}
